import { ROLES } from "../../../utils/constants";
import { canSeePsyNotes } from "../psychology/psyFeature";
import { getAllowedCategories } from "../case-management-notes/caseManagementFeature";

const ALLOWED_ROLES = [
	ROLES.admin,
	ROLES.tech_admin,
	ROLES.nfb_techncians,
	ROLES.theurapist,
	ROLES.nfb_and_theurapist,
	ROLES.client_owner,
	ROLES.neurofeedback_director,
	ROLES.technical_director,
	ROLES.shilan,
];

export const canSeeLogbook = (roleId?: string) => {
	const isAllowedRole = !!roleId && ALLOWED_ROLES.includes(roleId);
	return isAllowedRole;
};

const DETAIL_RESTRICTED_ROLES = [ROLES.nfb_techncians, ROLES.theurapist, ROLES.nfb_and_theurapist, ROLES.client_owner];

export const canSeeLogbookDetails = (userId?: string, roleId?: string, treatmentClientOwnerId?: string) => {
	const isRestrictedRole = !!roleId && DETAIL_RESTRICTED_ROLES.includes(roleId);
	if (!isRestrictedRole) return true;
	const isTreatmentClientOwner = !!userId && !!treatmentClientOwnerId && userId === treatmentClientOwnerId;
	return isTreatmentClientOwner;
};

const ORDERS_ALLOWED_ROLES = [ROLES.admin, ROLES.tech_admin, ROLES.technical_director];

export const canSeeLogbookOrders = (roleId?: string) => {
	const isAllowedRole = !!roleId && ORDERS_ALLOWED_ROLES.includes(roleId);
	return isAllowedRole;
};

export const getLogbookNoteFilter = (userId?: string, roleId?: string, treatmentClientOwnerId?: string) => {
	const allowedCaseCategories = getAllowedCategories(userId, roleId, treatmentClientOwnerId);
	const canSeePsy = canSeePsyNotes(userId, roleId);

	const categoryFilters: Array<any> = [];

	if (allowedCaseCategories.includes("geral")) {
		categoryFilters.push({ category: { _eq: "customer_support" } });
		categoryFilters.push({ category: { _eq: "client_owner" } });
		categoryFilters.push({ category: { _null: true } });
	} else {
		if (allowedCaseCategories.includes("customer_support")) {
			categoryFilters.push({ category: { _eq: "customer_support" } });
			categoryFilters.push({ category: { _null: true } });
		}
		if (allowedCaseCategories.includes("client_owner")) {
			categoryFilters.push({ category: { _eq: "client_owner" } });
		}
	}

	if (canSeePsy) {
		categoryFilters.push({ category: { _eq: "psychology" } });
	}

	if (categoryFilters.length === 0) return null;

	return { _or: categoryFilters };
};
